var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:[
    // Reset
    'focus:outline-none',
    'no-underline',
    'select-none',

    // Cursor
    'cursor-pointer',
    'hover-hover:disabled:cursor-not-allowed',

    // Animation
    'transition',

    // Text
    'font-sans',
    _vm.fontSizeClass,
    _vm.fontWeightClass,

    // Border
    'border-none',
    !_vm.isCustomBorderRadius && !_vm.isCustomButton && _vm.borderRadiusClass,

    // Layout and Sizing
    'flex',
    'items-center',
    'justify-center',
    'whitespace-nowrap',
    _vm.shouldFixHeight && _vm.heightSizeClass ].concat( (_vm.hasIconOnly ? [_vm.shouldFixWidth && _vm.widthSizeClass, _vm.shouldFixHeight && _vm.heightSizeClass, 'inline-flex'] : []),
    (_vm.hasIconAndText ? ['pl-4', 'pr-2'] : []),

    // Background color
    (!_vm.isCustomButton && _vm.isColorPrimary && !_vm.isTextButton
      ? [
          'bg-padlet-pink',
          'text-light-text-100',
          Object.assign({}, (!_vm.disabled && {
              // Hover + Active + Focus
              'hover-hover:hover:bg-padlet-pink-600': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
              'hover-hover:active:bg-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
              'hover-hover:focus:bg-padlet-pink-600': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
              'hover-hover:dark:hover:bg-padlet-pink-400': _vm.isBrowserDecidingDarkMode,
              'hover-hover:dark:active:bg-canary-500': _vm.isBrowserDecidingDarkMode,
              'hover-hover:dark:active:text-dark-text-100': _vm.isBrowserDecidingDarkMode,
              'hover-hover:dark:focus:bg-padlet-pink-400': _vm.isBrowserDecidingDarkMode,

              'hover-hover:hover:bg-padlet-pink-400': _vm.isForcedDark,
              'hover-hover:active:bg-canary-500': _vm.isForcedDark,
              'hover-hover:active:text-dark-text-100': _vm.isForcedDark,
              'hover-hover:focus:bg-padlet-pink-400': _vm.isForcedDark,
            }),
            // Disabled
            {'disabled:bg-light-ui-200': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
            'dark:disabled:bg-dark-ui-200': _vm.isBrowserDecidingDarkMode,
            'disabled:text-dark-text-disabled': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
            'dark:disabled:text-light-text-400': _vm.isBrowserDecidingDarkMode,

            'disabled:bg-dark-ui-200': _vm.isForcedDark,
            'disabled:text-light-text-400': _vm.isForcedDark}) ]
      : []),

    (!_vm.isCustomButton && _vm.isColorPulsingPrimary && !_vm.isTextButton
      ? [
          'bg-padlet-pink',
          'text-light-text-100',

          // Hover
          'hover-hover:hover:animate-pulse-bg-color',
          'pulse-bg-from-padlet-pink-500',
          'pulse-bg-to-grape-500',
          'dark:pulse-bg-to-canary-500',

          // Active
          'hover-hover:active:animate-none',
          'active:bg-grape-500',
          'dark:active:bg-canary-500',

          // Focus
          'hover-hover:focus:animate-none',
          'focus:bg-grape-500',
          'dark:focus:bg-canary-500',

          // Disabled
          'disabled:animate-none',
          'disabled:bg-light-ui-200',
          'dark:disabled:bg-dark-ui-200',
          'disabled:text-dark-text-disabled',
          'dark:disabled:text-light-text-400' ]
      : []),
    (!_vm.isCustomButton && _vm.isColorAlternative && !_vm.isTextButton
      ? [
          'bg-dark-ui-300',
          'dark:bg-light-ui-300',
          'text-light-text-200',
          'dark:text-dark-text-200' ].concat( (!_vm.disabled && [
            // Hover
            'hover-hover:hover:bg-dark-ui-400',
            'hover-hover:dark:hover:bg-light-ui-400',

            // Active
            'hover-hover:active:bg-grape-500',
            'hover-hover:active:text-light-text-100',
            'hover-hover:dark:active:bg-canary-500',
            'hover-hover:dark:active:text-dark-text-100',

            // Focus
            'hover-hover:focus:bg-dark-ui-400',
            'hover-hover:focus:text-light-text-100',
            'hover-hover:dark:focus:bg-light-ui-400',
            'hover-hover:dark:focus:text-dark-text-100' ]),
          // Disabled
          ['disabled:bg-light-ui-200'],
          ['dark:disabled:bg-dark-ui-200'],
          ['disabled:text-dark-text-400'],
          ['dark:disabled:text-light-text-400'] )
      : []),
    (!_vm.isCustomButton && _vm.isColorOrange && !_vm.isTextButton
      ? [
          'bg-tangerine-500',
          'text-light-text-100' ].concat( (!_vm.disabled && [
            // Hover
            'hover-hover:hover:animate-pulse-bg-color',
            'pulse-bg-from-tangerine-500',
            'pulse-bg-to-tangerine-600',

            // Active
            'hover-hover:active:animate-none',
            'active:bg-grape-500',
            'dark:active:bg-canary-500',

            // Focus
            'hover-hover:focus:animate-pulse-bg-color',
            'pulse-bg-from-tangerine-500',
            'pulse-bg-to-tangerine-600' ]),
          // Disabled
          ['disabled:bg-light-ui-200'],
          ['dark:disabled:bg-dark-ui-200'],
          ['disabled:text-dark-text-400'],
          ['dark:disabled:text-light-text-400'] )
      : []),
    (!_vm.isCustomButton && _vm.isColorSecondary && !_vm.isTextButton
      ? [
          _vm.isBrowserDecidingDarkMode && [
            _vm.xLessProminentBackground ? 'bg-light-ui-150' : 'bg-grey-100',
            _vm.xLessProminentBackground ? 'dark:bg-dark-ui-150' : 'dark:bg-grey-700',
            'text-dark-text-200',
            'dark:text-light-text-200',

            // Hover
            'hover-hover:hover:bg-grey-200',
            'hover-hover:dark:hover:bg-grey-600',

            // Focus
            'hover-hover:focus:bg-grey-200',
            'hover-hover:dark:focus:bg-grey-600',
            'hover-hover:focus:text-dark-text-100',
            'hover-hover:dark:focus:text-light-text-100',

            // Active
            'hover-hover:active:bg-grape-500',
            'hover-hover:dark:active:bg-canary-500',
            'hover-hover:active:text-light-text-100',
            'hover-hover:dark:active:text-dark-text-100',

            // Disabled
            'disabled:bg-grey-50',
            'dark:disabled:bg-grey-800',
            'disabled:text-dark-text-400',
            'dark:disabled:text-light-text-400',
            'hover-hover:disabled:bg-grey-50',
            'hover-hover:dark:disabled:bg-grey-800',
            'hover-hover:disabled:text-dark-text-400',
            'hover-hover:dark:disabled:text-light-text-400' ],
          _vm.isForcedDark && [
            _vm.xLessProminentBackground ? 'bg-dark-ui-150' : 'bg-grey-700',
            'text-light-text-200',

            // Hover
            'hover-hover:hover:bg-grey-600',

            // Focus
            'hover-hover:focus:bg-grey-600',
            'hover-hover:focus:text-light-text-100',

            // Active
            'hover-hover:active:bg-canary-500',
            'hover-hover:active:text-dark-text-100',

            // Disabled
            'disabled:bg-grey-800',
            'disabled:text-light-text-400',
            'hover-hover:disabled:bg-grey-800',
            'hover-hover:disabled:text-light-text-400' ],
          _vm.isForcedLight && [
            _vm.xLessProminentBackground ? 'bg-light-ui-150' : 'bg-grey-100',
            'text-dark-text-200',

            // Hover
            'hover-hover:hover:bg-grey-200',

            // Focus
            'hover-hover:focus:bg-grey-200',
            'hover-hover:focus:text-dark-text-100',

            // Active
            'hover-hover:active:bg-grape-500',
            'hover-hover:active:text-light-text-100',

            // Disabled
            'disabled:bg-grey-50',
            'disabled:text-dark-text-400',
            'hover-hover:disabled:bg-grey-50',
            'hover-hover:disabled:text-dark-text-400' ] ]
      : []),
    (_vm.isColorDanger && !_vm.isTextButton
      ? [
          'bg-danger-100',
          'text-white-100',

          // Hover + Active + Focus
          'hover-hover:hover:bg-scarlet-700',
          'hover-hover:focus:bg-scarlet-700',
          'hover-hover:active:bg-scarlet-700',

          // Disabled
          'disabled:bg-scarlet-700',
          'disabled:text-white-200' ]
      : []),
    (_vm.isColorDanger && !_vm.isTextButton
      ? [
          'bg-danger-100',
          'text-white-100',

          // Hover + Active + Focus
          'hover-hover:hover:bg-scarlet-700',
          'hover-hover:focus:bg-scarlet-700',
          'hover-hover:active:bg-scarlet-700',

          // Disabled
          'disabled:bg-scarlet-700',
          'disabled:text-white-200' ]
      : []),
    (!_vm.isCustomButton && _vm.isColorActive && !_vm.isTextButton
      ? ['font-semibold', 'bg-grape-500', 'dark:bg-canary-500', 'text-white-100', 'dark:text-highway-100']
      : []),
    (!_vm.isCustomButton && _vm.isTextButton
      ? [
          'bg-transparent' ].concat( (_vm.isColorPrimary
            ? [
                'text-padlet-pink',
                'hover-hover:hover:text-padlet-pink-800',
                'hover-hover:active:text-padlet-pink-800',
                'hover-hover:focus:text-padlet-pink-800',
                // Disabled
                { 'disabled:text-padlet-pink-100 dark:disabled:text-padlet-pink-900': _vm.isBrowserDecidingDarkMode },
                { 'disabled:text-padlet-pink-100': _vm.isForcedLight },
                { 'disabled:text-padlet-pink-900': _vm.isForcedDark } ]
            : []),
          (_vm.isColorSecondary
            ? [
                { 'text-dark-text-200': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'dark:text-light-text-200': _vm.isBrowserDecidingDarkMode },
                { 'text-light-text-200': _vm.isForcedDark },
                // Hover
                { 'hover-hover:hover:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:hover:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:hover:text-canary-500': _vm.isForcedDark },
                // Active
                { 'hover-hover:active:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:active:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:active:text-canary-500': _vm.isForcedDark },

                // Focus
                { 'hover-hover:focus:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:focus:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:focus:text-canary-500': _vm.isForcedDark },

                // Disabled
                { 'disabled:text-dark-text-400': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'dark:disabled:text-light-text-400': _vm.isBrowserDecidingDarkMode },
                { 'disabled:text-light-text-400': _vm.isForcedDark },

                { 'hover-hover:disabled:text-dark-text-400': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:disabled:text-light-text-400': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:disabled:text-light-text-400': _vm.isForcedDark } ]
            : []),
          (_vm.isColorDanger
            ? [
                'text-danger-100',
                'hover-hover:hover:text-scarlet-600',
                'hover-hover:active:text-scarlet-600',
                'hover-hover:focus:text-scarlet-600',
                // Disabled
                'disabled:text-scarlet-700',
                'dark:disabled:text-scarlet-700' ]
            : []),
          (_vm.isColorActive ? ['text-grape-500', 'dark:text-canary-500'] : []) )
      : []) ),attrs:{"href":_vm.href,"role":_vm.role,"disabled":_vm.disabled},on:{"click":_vm.click,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.handleSpaceKey($event)}}},[(_vm.iconName)?_c('OzIcon',{attrs:{"font":_vm.iconFont,"name":_vm.iconName,"size":_vm.iconSize,"dir":_vm.dir}}):_vm._e(),_vm._v(" "),(_vm.hasText)?_c('div',{ref:"text",class:['font-sans', _vm.xTextPadding ? 'px-5' : 'px-0']},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }